import {CountryPostalCodeCityComponent} from '@shared/ui/country-postal-code-city/country-postal-code-city.component';
import {isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TRANSLATE_CONFIG, TranslateConfig, FEATURE_FLAG_CONFIG} from '@brunata-angular/util';
import {provideRollbar} from '@brunata-angular/error-reporter';
import {
    AddressComponent,
    CheckboxGroupComponent,
    DatePipe,
    DateShortYearPipe,
    INPUT_TEXT_GROUP_DEFAULTS,
    LoadComponent,
    NumberPipe,
    TrueFalseComponent,
} from '@brunata-angular/ui';
import {InputDateGroupComponent} from '@brunata-angular/ui';
import {NgbDatepickerI18n, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgbDatepickerI18nImpl} from '@brunata-angular/ui';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {ControlMessagesComponent} from '@brunata-angular/ui';
import {POPOVER_ICON_DEFAULTS} from '@brunata-angular/ui';
import {InputTextAreaGroupComponent} from '@brunata-angular/ui';
import {KeyValuesRowComponent} from '@shared/ui/key-values-row/key-values-row.component';
import {InputNumberGroupComponent} from '@brunata-angular/ui';
import {InputTypeaheadComponent} from '@brunata-angular/ui';
import {ConfirmationDialogService} from '@brunata-angular/ui';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InputSelectOptionGroupComponent} from '@brunata-angular/ui';
import {EditLegislationComponent} from '@reporting/costs/edit-legislation/edit-legislation.component';
import {InputSearchComponent} from '@shared/ui/input-search/input-search.component';
import {EditEmailAddressModalComponent} from '@reporting/costs/edit-email-address-modal/edit-email-address-modal.component';
import {ChooseBetweenUploadAndManualReportingComponent} from '@reporting/consumers/choose-between-upload-and-manual-reporting/choose-between-upload-and-manual-reporting.component';
import {EditAccountPeriodModalComponent} from '@reporting/costs/edit-account-period-modal/edit-account-period-modal.component';
import {AddNewCostGroupModalComponent} from '@reporting/costs/add-new-cost-group-modal/add-new-cost-group-modal.component';
import {SortableTableHeaderComponent} from '@brunata-angular/ui';
import {EditAddressModalComponent} from '@reporting/costs/edit-address-modal/edit-address-modal.component';
import {ConsumerDataUploadComponent} from '@reporting/consumers/consumer-data-upload/consumer-data-upload.component';
import {ErrorInterceptor} from '@shared/utils/errorInterceptor';
import {ApproveResidentListModalComponent} from '@reporting/consumers/report-consumers-manual/approve-resident-list-modal/approve-resident-list-modal.component';
import {environment} from 'src/environments/environment';
import {featureFlagConfig} from './feature-flag.config';
import {ApproveUploadedConsumerDataModalComponent} from '@reporting/consumers/consumer-data-upload/approve-uploaded-consumer-data-modal/approve-uploaded-consumer-data-modal.component';
import {GalleryComponent} from '@shared/ui/gallery/gallery.component';
import {AUTH_CONFIG, AuthConfig, AuthInterceptor} from '@brunata-angular/auth';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {buildingReducer, locationReducer, meterReducer, userReducer} from 'src/app/state/reducers';
import {EffectsModule} from '@ngrx/effects';
import {Effects} from 'src/app/state/effects';
import {TimePipe} from '@brunata-angular/ui';

export const translateConfig: TranslateConfig = {
    webLangModules: [
        {application: 'common', module: 'brunata-angular-ui'},
        {application: 'online', module: 'common'},
        {application: 'online', module: 'systems'},
        {application: 'online', module: 'webArchive'},
        {application: 'online', module: 'ngonline'},
        {application: 'online', module: 'monitoringAlarms'},
        {application: 'webbill', module: 'calendar'},
        {application: 'webbill', module: 'onlinewebservice'},
        {application: 'online', module: 'reportagent'},
        {application: 'online', module: 'ReportAgentEmail'},
        {application: 'online', module: 'residents'},
        {application: 'online', module: 'landingPage'},
        {application: 'online', module: 'export'},
        {application: 'online', module: 'userAdministration'},
    ],
    supportedLanguages: [
        'da',
        'de',
        'en',
        'et',
        'fr',
        'hr',
        'hu',
        'it',
        'lv',
        'lt',
        'nl',
        'no',
        'pl',
        'sl',
        'sv',
    ],
    defaultLanguage: 'en',
    defaultApplication: 'online',
    defaultModule: 'ngonline',
    useFallbackLanguage: true,
};

const authConfig: AuthConfig = {
    oauthAuthorizeUrl: `${environment.oauthUrl}/authorize`,
    oauthTokenUrl: `${environment.oauthUrl}/oauth/token`,
    loginRedirectUrl: `auth-redirect`,
    oauthClientId: environment.oauthClientId,
    scope: `openid profile email`,
    interceptedUrls: [
        environment.onlineServiceUrl,
        environment.webArchiveServiceUrl,
        environment.selfServiceUrl,
    ],
};

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        LoadComponent,
        TrueFalseComponent,
        AddressComponent,
        NgbModule,
        InputDateGroupComponent,
        InputTextGroupComponent,
        InputTextAreaGroupComponent,
        InputNumberGroupComponent,
        InputTypeaheadComponent,
        InputSelectOptionGroupComponent,
        ControlMessagesComponent,
        NumberPipe,
        DatePipe,
        TimePipe,
        DateShortYearPipe,
        KeyValuesRowComponent,
        CheckboxGroupComponent,
        BrowserAnimationsModule,
        EditLegislationComponent,
        SortableTableHeaderComponent,
        InputSearchComponent,
        EditEmailAddressModalComponent,
        ChooseBetweenUploadAndManualReportingComponent,
        EditAccountPeriodModalComponent,
        AddNewCostGroupModalComponent,
        EditAddressModalComponent,
        CountryPostalCodeCityComponent,
        ConsumerDataUploadComponent,
        ApproveResidentListModalComponent,
        ApproveUploadedConsumerDataModalComponent,
        GalleryComponent,
        ToastrModule.forRoot({
            tapToDismiss: true,
            maxOpened: 5,
            timeOut: 10000,
            preventDuplicates: true,
            resetTimeoutOnDuplicate: true,
        }),
        StoreModule.forRoot({
            building: buildingReducer,
            meter: meterReducer,
            user: userReducer,
            location: locationReducer,
        }),
        StoreDevtoolsModule.instrument({maxAge: 25, logOnly: !isDevMode()}),
        EffectsModule.forRoot([Effects]),
    ],
    providers: [
        ConfirmationDialogService,
        {
            provide: TRANSLATE_CONFIG,
            useValue: translateConfig,
        },
        {provide: FEATURE_FLAG_CONFIG, useValue: featureFlagConfig},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {provide: AUTH_CONFIG, useValue: authConfig},
        ...provideRollbar({
            accessToken: environment.rollbarToken,
            environment: environment.env,
            enabled: environment.rollbarEnabled,
        }),
        {provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nImpl},
        // Preserve ngonline's pre-migration input-text-group behaviour (raw value, touched-on-change)
        // now that it uses the shared libs/ui component, whose defaults are trim + touched-on-blur.
        {
            provide: INPUT_TEXT_GROUP_DEFAULTS,
            useValue: {trim: false, markTouchedOnChange: true},
        },
        // Preserve ngonline's information-popover styling (custom-popover: bold, pre-line, 500px)
        // now that these inputs render the shared popover-icon instead of the local app-tooltip.
        {provide: POPOVER_ICON_DEFAULTS, useValue: {popoverClass: 'custom-popover'}},
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
